import * as React from "react";
import { SessionContextProvider, SessionContext } from "./SessionContextProvider";
import {
  BaseCoach,
  Profile,
  BasePlayer,
  AssistantPermission,
  PaymentDetails,
  Subscription,
  UserGroups,
} from "../interfaces/dtos";
import { Account } from "@socialcoach/services";
import { SocialCoachSession } from "@/services/bedrock";

export interface AppUserContext {
  account: SCAccount;
  profile: Profile;
  signUpStep?: string;
  coach?: BaseCoach;
  player?: BasePlayer;
  isAssistant?: boolean;
  permissions?: AssistantPermission[];
  subscriptions?: Subscription[];
  paymentMethods?: PaymentDetails[];
}

// export enum SCUserGroups {
//   COACH = "COACH",
//   PLAYER = "PLAYER",
//   ADMIN = "ADMIN",
//   EDITOR = "EDITOR",
// }

export interface SCAccount extends Account {
  username?: string;
  email?: string;
  accountType?: string; // "PROPIETARY";
  scGroups?: UserGroups[];
  isDemo?: boolean;
}

export interface AppContextState {
  userContext?: AppUserContext;
  session?: SocialCoachSession;
  clearSession: () => void;
  refreshSession: () => Promise<void>;
  loading: boolean;
}

export const AppContext = React.createContext<AppContextState>({
  clearSession: () => {},
  refreshSession: async () => {},
  loading: false,
});

type AppContextProviderProps = {
  children: React.ReactNode; // 👈️ type children
};

export const AppContextProvider: React.FC<AppContextProviderProps> = (props: AppContextProviderProps) => {
  return (
    <SessionContextProvider>
      <SessionContext.Consumer>
        {sessionContext => {
          const state = sessionContext as AppContextState;
          return <AppContext.Provider value={state}>{props.children}</AppContext.Provider>;
        }}
      </SessionContext.Consumer>
    </SessionContextProvider>
  );
};

// export const SessionContextProviderFC: React.FC<AppContextProviderProps> = (props: AppContextProviderProps) => {
//   return (<SessionContextProvider render={() => props.children}/>)
// }
